import { VITE_SOLANA_PUBLIC_NETWORK } from '@/env'

type SolanaCluster = 'devnet' | 'mainnet-beta'

// Solscan and explorer.solana.com both default to mainnet; non-mainnet clusters
// must be selected with a `?cluster=` query param (e.g. `?cluster=devnet`).
const withCluster = (url: string): string => {
  const cluster = VITE_SOLANA_PUBLIC_NETWORK as SolanaCluster
  return cluster === 'mainnet-beta' ? url : `${url}?cluster=${cluster}`
}

export const getSolanaExplorerAddressLink = (address: string): string =>
  withCluster(`https://explorer.solana.com/address/${address}`)

export const getSolscanTxLink = (txHash: string): string => withCluster(`https://solscan.io/tx/${txHash}`)
